"use strict";
exports.__esModule = true;
exports.toBoolean = void 0;
var toBoolean = function (data, _a) {
    var _b = _a === void 0 ? {} : _a, defaultValue = _b.defaultValue;
    if (data !== 'oui' && data !== 'non') {
        return !!defaultValue;
    }
    return data === 'oui';
};
exports.toBoolean = toBoolean;
//# sourceMappingURL=boolean.js.map